import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  Configuration,
  ProductsApi,
  DownloadsApi,
  GetDownloadResponse,
} from "api";
import { getBasePath } from "common/getConfiguration";
import { openSnackbar } from "features/ui";
import { AxiosError } from "axios";
import { isError } from "lodash";
import { getTranslationID } from "translation";
import { DownloadState } from "./state";

export const initialAsync = createAsyncThunk<
  DownloadState,
  void,
  {
    // rejectした時の返却値の型
    rejectValue: {
      /* Empty Object */
    };
  }
>("download/initialAsync", async (args, thunkApi) => {
  // apiのConfigurationを取得する
  const basePath = getBasePath();

  const config = new Configuration({ basePath });
  try {
    // ダウンロード一覧取得するAPI呼び出し
    const productsApi = new ProductsApi(config);
    const { data } = await productsApi.getProducts();
    return {
      apps: {
        initialize: "Initialized",
        isLoaded: true,
      },
      domains: {
        Products: data,
      },
    };
  } catch (e) {
    if (isAxiosError(e)) {
      if (e.response?.status === 401) {
        return thunkApi.rejectWithValue({});
      }
    }
    thunkApi.dispatch(
      openSnackbar({
        level: "error",
        message: getTranslationID("common.message.serverInternalError"),
      })
    );
    return thunkApi.rejectWithValue({});
  }
});

const isAxiosError = (arg: unknown): arg is AxiosError => {
  if (!isError(arg)) {
    return false;
  }
  const errorValue = arg as AxiosError;
  return errorValue.isAxiosError;
};

export const downloadAsync = createAsyncThunk<
  // 戻り値
  GetDownloadResponse,
  // 引数
  { downloadId: string },
  {
    // rejectした時の返却値の型
    rejectValue: {
      /* Empty Object */
    };
  }
>("download/downloadAsync", async (args, thunkApi) => {
  // apiのConfigurationを取得する
  const basePath = getBasePath();

  const { downloadId } = args;

  const config = new Configuration({ basePath });
  try {
    // ダウンロード取得API呼び出し
    const downloadsApi = new DownloadsApi(config);
    const { data } = await downloadsApi.getDownload(downloadId);
    return data;
  } catch (e) {
    thunkApi.dispatch(
      openSnackbar({
        level: "error",
        message: getTranslationID("common.message.serverInternalError"),
      })
    );
    return thunkApi.rejectWithValue({});
  }
});
// function to call api save download history
export const addDownloadRecordAsync = createAsyncThunk<
  void,
  { productId: string; productName: string },
  { rejectValue: string }
>(
  "download/addDownloadRecordAsync",
  async ({ productId, productName }, { rejectWithValue }) => {
    const basePath = getBasePath();
    const config = new Configuration({ basePath });
    try {
      const downloadsApi = new DownloadsApi(config);
      const data = await downloadsApi.saveHistoryDownload(
        productId,
        productName
      );
    } catch (error: any) {
      console.error("Failed to save download record:", error);
      return rejectWithValue(error.response?.data?.message);
    }
  }
);
